import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  standalone: true,
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
  imports: [
    IonicModule,
    CommonModule
  ]
})
export class TimePickerComponent {
  @Input({ required: true }) value: any;
  @Output() updateValue: EventEmitter<number> = new EventEmitter();

  isPickerOpen = false;

  colOptions = [...Array(60).keys()].map(value => { return { text: String(value), value } });
  minValue = 0;
  secValue = 0;

  setOpen(isOpen: boolean) {
    this.isPickerOpen = false;
    this.minValue = Math.floor(this.value / (1000 * 60));
    this.secValue = Math.floor(this.value /1000 - this.minValue * 60);
    this.isPickerOpen = isOpen;
  }

  onMinChange(ev) {
    this.minValue = ev.detail.value;
  }

  onSecChange(ev) {
    this.secValue = ev.detail.value;
  }

  dismissPicker(role: string) {
    if (role === 'confirm') {
      this.updateValue.emit((this.minValue * 60 + this.secValue) * 1000);
    }

    this.isPickerOpen = false;
  }

}
